<template>
  <RouterView :key="$route.fullPath" />
</template>
